import type { ICareerMainOurAwardsItem } from '~/domains/career/main/components/career-main-ourAwards/career-main-ourAwards.types'

export const CAREER_OUR_AWARDS_ITEMS: ICareerMainOurAwardsItem[] = [
  {
    image: '/images/career/ourAwards/logo-1.png',
    alt: 'Award 1',
  },
  {
    image: '/images/career/ourAwards/logo-2.png',
    alt: 'Award 2',
  },
  {
    image: '/images/career/ourAwards/logo-3.png',
    alt: 'Award 3',
  },
  {
    image: '/images/career/ourAwards/logo-4.svg',
    alt: 'Award 4',
  },
  {
    image: '/images/career/ourAwards/logo-5.png',
    alt: 'Award 5',
  },
  {
    image: '/images/career/ourAwards/logo-6.png',
    alt: 'Award 6',
  },
  {
    image: '/images/career/ourAwards/logo-7.png',
    alt: 'Award 7',
  },
  {
    image: '/images/career/ourAwards/logo-8.png',
    alt: 'Award 8',
  },
]

